module.exports = __webpack_public_path__ + "site/img/sock.5f6bde01.png";